import React from "react";
import "./style.scss";

const RangeSlider = ({
  label,
  min,
  max,
  step = 1,
  value,
  onChange,
  unit = "",
}) => {
  const [minVal, maxVal] = value;

  return (
    <div className="range-wrapper">
      {/* LABEL + VALUES */}
      <div className="range-header">
        <span className="range-label">{label}</span>
        <span className="range-value">
          {minVal}
          {unit} — {maxVal}
          {unit}
        </span>
      </div>

      {/* SLIDER */}
      <div className="range-container">
        {/* BASE TRACK */}
        <div className="range-track" />

        {/* ACTIVE RANGE */}
        <div
          className="range-active"
          style={{
            left: `${((minVal - min) / (max - min)) * 100}%`,
            right: `${100 - ((maxVal - min) / (max - min)) * 100}%`,
          }}
        />

        {/* MIN THUMB */}
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={minVal}
          onChange={(e) =>
            onChange([
              Math.min(Number(e.target.value), maxVal - step),
              maxVal,
            ])
          }
          className="range-thumb"
        />

        {/* MAX THUMB */}
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={maxVal}
          onChange={(e) =>
            onChange([
              minVal,
              Math.max(Number(e.target.value), minVal + step),
            ])
          }
          className="range-thumb"
        />
      </div>
    </div>
  );
};

export default RangeSlider;
